// Renders the social information for an object with like/unlike

import { useCallback } from 'react'
import PropTypes from 'prop-types'
import { graphql, compose } from 'react-apollo'
import { CreateFavorite, DeleteFavorite } from '~/queries/favorite.gql'
import { QueryFavoriteResources } from '~/queries/resource.gql'
import { QueryFavoriteFaqLists } from '~/queries/faq.gql'
import { QueryFavoriteReports } from '~/queries/report.gql'
import useLock from '~/hooks/useLock'

// Info needed for each favorite type
const FAVORITE_INFO = {
  RESOURCE: {
    query: QueryFavoriteResources
  },
  FAQ: {
    query: QueryFavoriteFaqLists
  },
  REPORT: {
    query: QueryFavoriteReports
  }
}

function Favorite ({ isFavorited, createFavorite, deleteFavorite }) {
  const [handleCreate] = useLock(useCallback(createFavorite, []))
  const [handleDelete] = useLock(useCallback(deleteFavorite, []))

  const starColor = isFavorited ? 'text-warning' : 'text-light'
  const starFunction = isFavorited ? handleDelete : handleCreate

  return (
    <a>
      <i className={`fa fa-star fa-lg pr-1 ${starColor}`} onClick={() => starFunction()} />
    </a>
  )
}

Favorite.propTypes = {
  isFavorited: PropTypes.bool.isRequired,
  objectType: PropTypes.string.isRequired,
  objectId: PropTypes.string.isRequired,
  createFavorite: PropTypes.func,
  deleteFavorite: PropTypes.func
}

const withCreateFavorite = graphql(CreateFavorite, {
  name: 'createFavorite',
  props: ({ createFavorite, ownProps: { objectType, objectId } }) => ({
    createFavorite: () => createFavorite({
      variables: { input: { objectType, objectId } },
      update: (cache, { data: { createFavorite } }) => {
        try {
          // Get favorite list and add new one
          const data = cache.readQuery({ query: FAVORITE_INFO[objectType].query })

          data.favorites.push(createFavorite)
          cache.writeQuery({ query: FAVORITE_INFO[objectType].query, data })
        } catch (error) {}
      }
    })
  })
})

const withDeleteFavorite = graphql(DeleteFavorite, {
  name: 'deleteFavorite',
  props: ({ deleteFavorite, ownProps: { objectType, objectId } }) => ({
    deleteFavorite: () => deleteFavorite({
      variables: { objectType, objectId },
      update: cache => {
        try {
          // Get favorite list and remove this one
          const data = cache.readQuery({ query: FAVORITE_INFO[objectType].query })

          data.favorites = data.favorites.filter(f => f.objectId !== objectId)
          cache.writeQuery({ query: FAVORITE_INFO[objectType].query, data })
        } catch (error) {}
      }
    })
  })
})

export default compose(
  withCreateFavorite,
  withDeleteFavorite
)(Favorite)
